import React from "react";
import { Button, CircularProgress, ButtonProps } from "@mui/material";

interface BSWButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

const BSWButton: React.FC<BSWButtonProps> = ({
  children,
  loading = false,
  loadingText,
  disabled,
  sx,
  ...props
}) => {
  // Default styles for BSWButton
  const defaultStyles = {
    minWidth: 120,
    height: 42,
    fontSize: '1rem',
    textTransform: 'none' as const,
    borderRadius: 1,
    fontWeight: 500,
    backgroundColor: '#rgba(25, 118, 210, 1)',
  };

  return (
    <Button
      variant="contained"
      size="medium"
      startIcon={
        loading ? <CircularProgress size={20} color="inherit" /> : undefined
      }
      disabled={disabled || loading}
      sx={{ ...defaultStyles, ...sx }}
      {...props}
    >
      {loading ? loadingText || "Loading..." : children}
    </Button>
  );
};

export default BSWButton;
